module.exports = __webpack_public_path__ + "static/mind_flayer-4cf3bf12f4436f6362a74674aeaedac7.jpeg";